export function cleanString<T extends string>(input: T) {
    return input.trim();
}
